/* eslint-disable camelcase */
import React, { useEffect, useState, useMemo } from 'react';

import CasinoCRMApi from '../../../../casino/Api/CRM/CasinoCRMApi';
import {
    GetAllCasinoGameCategoryResponse,
    GetCasinoGameCategoryResponse,
} from '../../../../casino/Api/CRM/Responses/CasinoGameCategoryResponse';
import CreateButton from '../../../elements/CreateButton';
import DeleteButton from '../../../elements/DeleteButton';
import EditButton from '../../../elements/EditButton';
import Loader from '../../../elements/Loader';
import TableDraggable from '../../../elements/TableDraggable';
import ViewButton from '../../../elements/ViewButton';
import { API_CASINO_GAME_CATEGORIES_DELETE } from '../Helpers/CrmApiUrls';
import { CRM_PERMISSION } from '../Helpers/CrmPermissions';
import { CASINO_GAME_CATEGORY_CREATE, CASINO_GAME_CATEGORY_EDIT, CASINO_GAME_CATEGORY_SHOW } from '../Helpers/CrmUrls';
import { replaceUrlParams } from '../Helpers/UrlHelper';

function GameCategoryList() {
    const [categories, setCategories] = useState<GetAllCasinoGameCategoryResponse>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const getGameCategories = async () => {
        setIsLoading(true);
        setCategories(await CasinoCRMApi.gameCategories.getAll());
        setIsLoading(false);
    };

    useEffect(() => {
        getGameCategories();
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'casino_game_category_translations[0].name',
            },
            {
                Header: 'Slug',
                accessor: 'casino_game_category_translations[0].slug',
            },
            {
                Header: 'Actions',
                accessor: 'details',
                Cell: ({ row }: { row: { original: GetCasinoGameCategoryResponse } }) => (
                    <div>
                        <ViewButton
                            url={replaceUrlParams(CASINO_GAME_CATEGORY_SHOW, { id: row.original.id })}
                            permissions={[CRM_PERMISSION.GAME_CATEGORY_SHOW]}
                            key="view"
                        />
                        <EditButton
                            url={replaceUrlParams(CASINO_GAME_CATEGORY_EDIT, { id: row.original.id })}
                            permissions={[CRM_PERMISSION.GAME_CATEGORY_EDIT]}
                            key="edit"
                        />
                        {row.original.is_all_games === false && (
                            <DeleteButton
                                url={replaceUrlParams(API_CASINO_GAME_CATEGORIES_DELETE, { id: row.original.id })}
                                permissions={[CRM_PERMISSION.GAME_CATEGORY_DELETE]}
                                key="delete"
                                action={getGameCategories}
                            />
                        )}
                    </div>
                ),
            },
        ],
        []
    );

    const onDropCallback = async (order: number[]) => {
        CasinoCRMApi.gameCategories.updateOrder(order);
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <span>All game categories</span>
                <CreateButton
                    url={CASINO_GAME_CATEGORY_CREATE}
                    permissions={[CRM_PERMISSION.GAME_CATEGORY_CREATE]}
                    key="create"
                    buttonText="Create new category"
                />
            </div>
            <div className="card-body">
                <Loader
                    loading={isLoading}
                    content={() => (
                        <TableDraggable columns={columns} data={categories} onDropCallback={onDropCallback} />
                    )}
                />
            </div>
        </div>
    );
}

export default GameCategoryList;
